import { Collapse as MantineCollapse, CollapseProps } from '@mantine/core';

export type ICollapseProps = CollapseProps;

/** @registry Design-layer pass-through over Mantine Collapse; import this instead of @mantine/core Collapse outside src/design. */
export const Collapse = MantineCollapse;
